import type { CountryCode } from './common';
import { USA_HOLIDAYS } from './holidays/usa';
import { UK_HOLIDAYS } from './holidays/uk';
import { CANADA_HOLIDAYS } from './holidays/canada';
import { MEXICO_HOLIDAYS } from './holidays/mexico';

export interface Holiday {
    name: string;
    date: Date;
}

type YearlyHolidays = Record<number, Holiday[]>;
type CountryHolidays = Record<CountryCode, YearlyHolidays>;

export const COUNTRY_FLAGS: Record<CountryCode, string> = {
    'USA': '🇺🇸',
    'UK': '🇬🇧',
    'Canada': '🇨🇦',
    'Mexico': '🇲🇽'
};

export const HOLIDAYS: CountryHolidays = {
    'USA': USA_HOLIDAYS,
    'UK': UK_HOLIDAYS,
    'Canada': CANADA_HOLIDAYS,
    'Mexico': MEXICO_HOLIDAYS
};
